import './login.scss';

import { Button, Card, CardContent, CircularProgress, TextField, Typography } from '@mui/material';
import { useAtom } from 'jotai';
import { ChangeEvent, FC, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { regionId, userTypeAtom } from '../../atoms/atom';
import imgHome from '../../images/logo.png';
import { LoginService } from '../../services/LoginService';
import { LoginDTO } from '../../types/LoginDTO';

const Login: FC = () => {
	const accessToken = localStorage.getItem('access-token');
	const [, setRegionAtom] = useAtom(regionId);
	const [, setUserTypeAtom] = useAtom(userTypeAtom);
	const [invalidLogin, setInvalidLogin] = useState(false);
	const [username, setUser] = useState('');
	const [password, setPassword] = useState('');
	const [loading, setLoading] = useState(false);
	const service = new LoginService();
	const navigate = useNavigate();

	async function handleLogin() {
		setLoading(true);
		const body = {
			username: username,
			password: password
		} as LoginDTO;
		const responseLogin = await service.autentica(body);
		if (responseLogin && responseLogin.data) {
			if (responseLogin.status === 403) {
				setInvalidLogin(true);
				return;
			}
			setUserTypeAtom(responseLogin.data.userType);
			setRegionAtom(responseLogin.data.region);
			localStorage.setItem('access-token', responseLogin.data.accessToken);
			localStorage.setItem('username', responseLogin.data.username);
			localStorage.setItem('region', responseLogin.data.region?.toString());
			if (responseLogin.data.modules.includes('INICIO')) {
				navigate(`/inicio`);
			} else if (responseLogin.data.modules.includes('FORMS')) {
				navigate(`/formularios`);
			}
		} else {
			setInvalidLogin(true);
		}
		setLoading(false);
	};

	const handleKeyDown = (event: React.KeyboardEvent) => {
		if (event.key === 'Enter') {
			event.preventDefault();
			handleLogin();
		}
	};

	const handleUser = (event: ChangeEvent<HTMLInputElement>) => {
		setUser(event.target.value);
	}

	const handlePassword = (event: ChangeEvent<HTMLInputElement>) => {
		setPassword(event.target.value);
	}

	useEffect(() => {
		if (accessToken && accessToken !== "") {
			navigate(`/inicio`);
		}
	}, [accessToken]);

	return (
		<div className="login-container">
			<Card className="login-card" elevation={6}>
				<CardContent className="login-content" onKeyDown={handleKeyDown}>
					<div className="logo-wrapper">
						<img
							src={imgHome}
							alt="Logo da Empresa"
							className="company-logo"
						/>
					</div>
					<TextField
						fullWidth
						margin="normal"
						label="E-mail"
						variant="outlined"
						value={username}
						onChange={handleUser}
						InputLabelProps={{ style: { color: "#bbb" } }}
					/>
					<TextField
						fullWidth
						margin="normal"
						label="Senha"
						type="password"
						variant="outlined"
						value={password}
						onChange={handlePassword}
						InputLabelProps={{ style: { color: "#bbb" } }}
					/>
					{invalidLogin && (
						<Typography variant="body2" className="error-message">
							E-mail ou senha inválidos.
						</Typography>
					)}
					<Button
						fullWidth
						variant="contained"
						color="primary"
						className="login-button"
						onClick={handleLogin}
						disabled={!username || !password}
					>
						{loading
							? <CircularProgress sx={{color: "#292929ff"}} size={'25px'}/>
							: "Login"
						}
					</Button>
				</CardContent>
			</Card>
		</div>
	);
}

export default Login;